import { APP_MOUNT_POINT_SELECTOR, GTM_ID, MTA_ACTOR_COOKIE } from '@/config';
import CookieHelper from '@/utils/cookies';
import { createGtm } from '@gtm-support/vue-gtm';
import VueAnnouncer from '@vue-a11y/announcer';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import i18n from './i18n';
import router from './router';

const pinia = createPinia();
const app = createApp(App);

app
  .use(pinia)
  .use(VueAnnouncer, { router: false, message: '', politeness: 'polite' })
  .use(router)
  .use(i18n);

// On ne charge simplement pas GTM si le témoin qui contient le nom de l'acteur (personne qui assume l'identité du
// client) est présent. Le but est d'éviter d'ajouter des métriques qui ne proviennent pas de vrais clients et comme les
// compagnies de taxi vont assumer l'identité des clients pour faire des réservations sans avoir accès à HOD, le volume
// pourrait être assez important.
//
// Note: il n'y a pas de réactivité pour réactiver GTM si, par exemple, on se connecte normalement sans rafraichir la
// page. La raison est que c'est assez rare.
if (import.meta.env.MODE !== 'e2e' && !new CookieHelper().getCookie(MTA_ACTOR_COOKIE)) {
  const aScriptTag = document.querySelector('script[nonce]');
  app.use(createGtm({
    id: GTM_ID,
    vueRouter: router,
    nonce: aScriptTag instanceof HTMLScriptElement ? aScriptTag.nonce : '',
    debug: import.meta.env.MODE === 'development',
  }));
}

app.mount(APP_MOUNT_POINT_SELECTOR);
